import type { ImageOnlyProductCard } from "@/types/product";

import PC from "../../ProductCardTemplate";

const { Card, Gallery } = PC;

const NewlySeenProductCard = ({ data }: { data: ImageOnlyProductCard }) => {
  if (!data) return null;
  const { core, gallery } = data;
  return (
    <>
      <Card slug={core?.slug ?? "#"} name={core?.name ?? ""}>
        <Gallery
          url={gallery?.image?.uri ?? ""}
          alt={gallery?.image?.alt ?? ""}
          secondImage={gallery?.secondImage}
        />
      </Card>
    </>
  );
};

export default NewlySeenProductCard;
